import React from 'react';
import moment from 'moment';
import {
  object, number,
} from 'yup';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

const defaults = {
  active: false,
  startAt: {
    date: moment().format('YYYY-MM-DD'),
    time: '00:00',
  },
  endAt: {
    date: '',
    time: '',
  },
  src: '',
  page: '',
  location: '',
  description: '',
};

const FormBanner = ({
  banner,
}) => (
  <FormResource
    {...{
      defaults,
      // schema: object({
      // }),
      stored: banner ? {
        ...banner,
        startAt: {
          date: moment(banner.startAt).format('YYYY-MM-DD'),
          time: moment(banner.startAt).format('HH:mm'),
        },
        endAt: {
          date: moment(banner.endAt).format('YYYY-MM-DD'),
          time: moment(banner.endAt).format('HH:mm'),
        },
      } : undefined,
      api: '/api/site/banners',
      onSubmit: (v) => ({
        ...v,
        startAt: moment(
          `${v.startAt.date} ${v.startAt.time}`,
          'YYYY-MM-DD HH:mm',
        ).toDate(),
        endAt: moment(
          `${v.endAt.date} ${v.endAt.time}`,
          'YYYY-MM-DD HH:mm',
        ).toDate(),
      }),
    }}
  >
    <div className="row">
      <div className="col">
        <FormGroup name="page" label="Page"/>
      </div>
      <div className="col">
        <FormGroup name="location" label="Location"/>
      </div>
    </div>

    <FormGroup name="description" />

    <div className="row">
      <div className="col-auto">
        <div className="form-group">
          <label>Active</label>
          <FormCheckGroup
            name="active"
            type="checkbox"
            label=""
            asSwitch
          />
        </div>
      </div>
      <div className="col">
        <div className="form-row">
          <div className="col">
            <FormGroup
              name="startAt.date"
              type="date"
              label="Start Date"
            />
          </div>
          <div className="col">
            <FormGroup name="startAt.time" type="time" label="Time" />
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <FormGroup
              name="endAt.date"
              type="date"
              label="End Date"
            />
          </div>
          <div className="col">
            <FormGroup name="endAt.time" type="time" label="Time" />
          </div>
        </div>
      </div>
    </div>

    <FormGroup
        name="src"
        label="Image"
        as="coverImg"
        api="/api/site/banners/files"
    />

  </FormResource>
);

export default FormBanner;
